/**
 * App 混合栈 refer 闭环（H5→原生方向）：把 spm 透传注入到跳转原生页面的
 * 桥接方法参数中（JumpToPage / jumpGoodsDetail / jumpGoodsList）。原生侧再打开
 * H5 时以 ?spm= 传回，读取逻辑见 spm-session（原生→H5 方向）。
 *
 * provider 运行时注入而非直接 import：utils 层不得反向依赖 reporting 层。
 */
import appCommunicationManager from '@/utils/app-communication-manager';

import { getSpmForAppNativeJump } from './spm-session';

let installed = false;

/** 启动时调用一次（幂等）：注册跳转方法的 spm 参数提供者。 */
export function installSpmAppJumpParam(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  appCommunicationManager.setSpmParamProvider(getSpmForAppNativeJump);
}
